var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-0 row mb-3"},[_c('div',{staticClass:"col position-relative"},[_c('div',{staticClass:"input-group-bordered rounded py-4"},[_c('div',{staticClass:"mt-2 mt-md-4 row mx-1"},[_vm._t("default")],2)]),_c('div',{staticClass:"position-absolute px-2 form-group-label"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }